import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useAllocateTrait, useWaifuReference } from '@/api/queries';
import { hapticNotify } from '@/lib/telegram';
import { useUIStore } from '@/store/uiStore';

interface TraitSelectorProps {
  open: boolean;
  onClose: () => void;
  waifuId: number;
  userId: number;
  excludeTraitIds: Set<string>;
}

export function TraitSelector({ open, onClose, waifuId, userId, excludeTraitIds }: TraitSelectorProps) {
  const { data: ref } = useWaifuReference();
  const allocate = useAllocateTrait(waifuId, userId);
  const pushNotification = useUIStore((s) => s.pushNotification);

  const traits = (ref?.traits ?? []).filter((t) => !excludeTraitIds.has(t.id));

  return (
    <Modal open={open} onClose={onClose} title="Новый трейт" size="md">
      <div className="p-4 space-y-2">
        {traits.length === 0 ? (
          <div className="text-white/50 text-sm">Нет доступных трейтов.</div>
        ) : (
          traits.map((trait) => (
            <Button
              key={trait.id}
              variant="secondary"
              fullWidth
              onClick={async () => {
                try {
                  await allocate.mutateAsync(trait.id);
                  hapticNotify('success');
                  pushNotification({
                    type: 'success',
                    message: `Получен трейт: ${trait.name}`,
                  });
                  onClose();
                } catch (err) {
                  hapticNotify('error');
                  const message =
                    err instanceof Error ? err.message : 'Не удалось выбрать трейт';
                  pushNotification({ type: 'error', message });
                }
              }}
            >
              <div className="text-left">
                <div className="font-medium">{trait.name}</div>
                {trait.description && (
                  <div className="text-xs text-white/50">{trait.description}</div>
                )}
              </div>
            </Button>
          ))
        )}
      </div>
    </Modal>
  );
}
